module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QscFR42fcVwbAAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAADpSURBVFjDY2CgANzP8/p/P8/rPyVmMDEMMBh1wKgDRh3Agsw55Kn4n4GBgWHpvY8oimbefMeIzE9XF/qPjY+ujhjzBjwEGNFLNgYGBobHt68zMDAwMMiqaqIohonDAEy+Y+cJvJZEK/Gj8O223x+kIYAetzCX4woJmDiMjx7XuMCgSgMouaDC3QJrXOMCxKpDTwMzb74bpOUAempGdzm6j9HjHKYeXRxf2hiaaQCW+qMZiEv9wycNkAuGXxogFQzfNICeG0ZOGiA1jQzqNIC3PQALEWJDYEi2B/C2CbG14UjtPRMyb8BDAACp64byz2TK/AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/game/assets/tanks/enemy_red.png
// module id = 73
// module chunks = 0